import $ from 'jquery';

$(document).ready(() => {
  
  moveFilters();
  $(document).on('as4-Before-Set-Results-Contents', function(e, idSearch, context) {
    moveFilters();
    $('.PM_ASSelectionsBlock').insertAfter($('.PM_ASForm'));
  });

  $(document).on('click', '.PM_ASCriterionsGroupTitle', function() {
    $('.PM_ASCriterionsGroupTitle').removeClass('font-weight-bold');
    $(this).addClass('font-weight-bold');
    var targetFiler = $(this).data('target-filter');
    $('.PM_ASCriterionsGroupOuter').addClass('d-none');
    $(targetFiler).removeClass('d-none');
  });
    
});

function moveFilters() {
  $('<div id="filters-moved" class="filters-moved"></div>').insertAfter($('.PM_ASCriterionsGroupList'));
  $('.PM_ASResetSearch').appendTo($('#PM_ASResetSearch'));
  $('.PM_ASearchTitle').prependTo($('.PM_ASCriterionsGroupList'));
  $('.PM_ASCriterionsGroupOuter').appendTo($('#filters-moved'));
  $('.PM_ASSelectionsBlock').insertAfter($('.PM_ASForm'));
}
